export { default as ITeroOrderAdditionalInfo } from './ITeroOrderAdditionalInfo';
export * as Styled from './ITeroOrderAdditionalInfo.styles';
export * from './ITeroOrderAdditionalInfo.types';
